export default {"src":"/_next/static/media/InPartnershipWithPillTimeLogo.f9afb499.svg","height":32,"width":248,"blurWidth":0,"blurHeight":0};